// Add CSS for contentEditable placeholders and dynamic animations
export const injectCSS = () => {
  if (document.getElementById('rich-editor-styles')) return;
  
  const style = document.createElement('style');
  style.id = 'rich-editor-styles';
  style.textContent = `
    /* Global dark mode styles */
    html.dark {
      background-color: #0f172a; /* slate-900 */
      color: #e2e8f0; /* slate-200 */
    }
    
    html.dark body {
      background-color: #0f172a; /* slate-900 */
      color: #e2e8f0; /* slate-200 */
    }
    
    html.dark #root {
      background-color: #0f172a; /* slate-900 */
      color: #e2e8f0; /* slate-200 */
    }
    
    body.dark {
      background-color: #0f172a; /* slate-900 */
      color: #e2e8f0; /* slate-200 */
    }
    
    [contenteditable]:empty::before {
      content: attr(data-placeholder);
      color: #9ca3af;
      font-style: italic;
      pointer-events: none;
    }
    [contenteditable]:empty:focus::before {
      color: #6b7280;
    }
    .dark [contenteditable]:empty::before {
      color: #6b7280;
    }
    .dark [contenteditable]:empty:focus::before {
      color: #9ca3af;
    }
    
                 /* Dynamic flowing lines animation */
             @keyframes flow-line {
               0% {
                 transform: rotate(var(--rotation)) translateX(-300%);
                 opacity: 0;
               }
               15%, 85% {
                 opacity: 0.4;
               }
               100% {
                 transform: rotate(var(--rotation)) translateX(300%);
                 opacity: 0;
               }
             }
             
             .flowing-line {
               animation: flow-line 12s linear infinite;
               animation-fill-mode: both;
             }
             
             .flowing-line.restart-animation {
               animation: none;
               animation: flow-line 12s linear infinite;
               animation-fill-mode: both;
             }
             
             .flowing-line:nth-child(1) { animation-delay: 0s; }
             .flowing-line:nth-child(2) { animation-delay: 3s; }
             .flowing-line:nth-child(3) { animation-delay: 6s; }
             .flowing-line:nth-child(4) { animation-delay: 9s; }
             
             /* Rainbow color flow animation for headlines */
             @keyframes rainbow-flow {
               0% {
                 background-position: 100% 50%;
               }
               25% {
                 background-position: 75% 50%;
               }
               50% {
                 background-position: 50% 50%;
               }
               75% {
                 background-position: 25% 50%;
               }
               100% {
                 background-position: 0% 50%;
               }
             }
             
             .rainbow-headline {
               background: linear-gradient(
                 90deg,
                 #059669, /* emerald-600 */
                 #0d9488, /* teal-600 */
                 #16a34a, /* green-600 */
                 #059669, /* emerald-600 */
                 #0d9488, /* teal-600 */
                 #16a34a  /* green-600 */
               );
               background-size: 300% 100%;
               background-clip: text;
               -webkit-background-clip: text;
               color: transparent;
               animation: rainbow-flow 6s ease-in-out infinite;
             }
              
              /* Animated rainbow for brand header using existing blue→purple gradient */
              .brand-rainbow {
                background: linear-gradient(
                  90deg,
                  #2563eb, /* blue-600 */
                  #9333ea, /* purple-600 */
                  #2563eb, /* blue-600 */
                  #9333ea  /* purple-600 */
                );
                background-size: 300% 100%;
                background-clip: text;
                -webkit-background-clip: text;
                color: transparent;
                animation: rainbow-flow 6s ease-in-out infinite;
              }
             
             .ai-frame-rainbow {
               background: linear-gradient(
                 90deg,
                 #059669, /* emerald-600 */
                 #0d9488, /* teal-600 */
                 #16a34a, /* green-600 */
                 #059669, /* emerald-600 */
                 #0d9488, /* teal-600 */
                 #16a34a  /* green-600 */
               );
               background-size: 400% 100%;
               background-clip: text;
               -webkit-background-clip: text;
               color: transparent;
               animation: ai-rainbow-flow 8s ease-in-out infinite;
             }
             
             @keyframes ai-rainbow-flow {
               0% {
                 background-position: 0% 50%;
               }
               50% {
                 background-position: 100% 50%;
               }
               100% {
                 background-position: 0% 50%;
               }
             }
             
             @keyframes ai-rainbow-flow {
              0% {
                background-position: 0% 50%;
              }
              50% {
                background-position: 100% 50%;
              }
              100% {
                background-position: 0% 50%;
              }
            }
            
            .shadow-3xl {
              box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25), 0 0 0 1px rgba(255, 255, 255, 0.05);
            }
            
            .shadow-3xl:hover {
              box-shadow: 0 35px 60px -12px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(255, 255, 255, 0.1);
            }

             /* Dark-green only gradient for KI-Assistent headline */
             .ai-headline-darkgreen {
               background: linear-gradient(90deg, #064e3b, #065f46, #064e3b);
               background-size: 100% 100%;
               background-clip: text;
               -webkit-background-clip: text;
               color: transparent;
             }
    
    /* Ensure icons are properly displayed */
    svg[role="img"] {
      display: inline-block;
      vertical-align: middle;
    }
    
    /* Icon sizing consistency */
    .w-5.h-5 svg,
    .w-6.h-6 svg,
    .w-8.h-8 svg {
      width: 100%;
      height: 100%;
    }
  `;
  document.head.appendChild(style);
};

// Initialize CSS injection
export const initializeCSS = () => {
  // Inject CSS when app loads - ensure it runs immediately
  if (typeof window !== 'undefined') {
    // Run immediately
    injectCSS();
    // Also run after DOM is loaded
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', injectCSS);
    }
    // Additional call to ensure CSS is loaded
    setTimeout(injectCSS, 100);
  }
};
